import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { PlayableListTab } from '../ProjectDetail/PlayableListTab';

/**
 * 独立的试玩管理页面
 * 路由：/project/:projectId/playables
 */
export function PlayableManagement(): JSX.Element {
  const { projectId } = useParams<{ projectId: string }>();
  const navigate = useNavigate();

  if (!projectId) {
    return (
      <div className="flex h-screen items-center justify-center">
        <p className="text-muted-foreground">项目 ID 缺失</p>
      </div>
    );
  }

  return (
    <div className="flex h-screen flex-col bg-background">
      {/* 顶部导航栏 */}
      <div className="flex items-center gap-3 border-b border-border/60 bg-card/40 px-4 py-3">
        <button
          onClick={() => navigate(`/creation/${projectId}`)}
          className="flex items-center gap-1.5 rounded-lg border border-border/50 px-3 py-1.5 text-sm text-foreground/80 transition-colors hover:border-primary/50 hover:text-primary"
        >
          <ArrowLeft size={14} />
          返回工作区
        </button>
        <div className="h-4 w-px bg-border/60" />
        <h1 className="text-sm font-semibold text-foreground">试玩管理</h1>
      </div>

      {/* 试玩列表 */}
      <PlayableListTab
        projectId={projectId}
        onSwitchToWorkspace={(sessionId, playableId) => {
          // 跳转回工作区并加载指定会话和版本
          navigate(`/creation/${projectId}?session=${sessionId}&version=${playableId}`);
        }}
      />
    </div>
  );
}
